import { Component, OnInit } from '@angular/core';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {FlatTreeControl} from '@angular/cdk/tree';

interface CreateMeetingNav {
  name: string;
  children?: CreateMeetingNav[];
}

const TEMPLATE_DATA: CreateMeetingNav[] = [
  {
    name: 'CATEGORY 1',
    children: [
      {name: 'Apple'},
      {name: 'Banana'},
      {name: 'Fruit loops'},
    ]
  }, 
  {
    name: 'CATEGORY 2',
    children: [
      {
        name: 'Green',
        children: [
          {name: 'Broccoli'},
          {name: 'Brussels sprouts'},
        ]
      }, {
        name: 'Orange',
        children: [
          {name: 'Pumpkins'},
          {name: 'Carrots'},
        ]
      },
    ]
  },
  {
    name: 'CATEGORY 3',
    children: [
      {name: 'Apple'},
      {name: 'Banana'},
      {name: 'Fruit loops'},
    ]
  },
  {
    name: 'CATEGORY 4',
    children: [
      {name: 'Requirement Discussion'},
      {name: 'Status update'}
    ]
  },
  {
    name: 'CATEGORY 5',
    children: [
      {name: 'Apple'},
      {name: 'Banana'},
      {name: 'Fruit loops'},
    ]
  },
  {
    name: 'CATEGORY 6',
    children: [
      {name: 'Apple'},
      {name: 'Banana'},
      {name: 'Fruit loops'},
    ]
  },
  {
    name: 'CATEGORY 7',
    children: [
      {name: 'Apple'},
      {name: 'Banana'},
      {name: 'Fruit loops'},
    ]
  },
  {
    name: 'CATEGORY 8',
    children: [
      {name: 'Apple'},
      {name: 'Banana'},
      {name: 'Fruit loops'},
    ]
  }
];
interface TemplateFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}
@Component({
  selector: 'app-create-meeting-navigator',
  templateUrl: './create-meeting-navigator.component.html',
  styleUrls: ['./create-meeting-navigator.component.css']
})
export class CreateMeetingNavigatorComponent implements OnInit {

  constructor() { 
    this.dataSource.data = TEMPLATE_DATA;
  }

  private _transformer = (node: CreateMeetingNav, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
    };
  }

  treeControl = new FlatTreeControl<TemplateFlatNode>(
    node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);


  ngOnInit(): void {
  }

  hasChild = (_: number, node: TemplateFlatNode) => node.expandable;

}
